module.exports = __webpack_public_path__ + "static/carrier-payment-81ec21dfc6cbee22ecc072505648ff5c.png";